var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.574 7.222a1.925 1.925 0 0 0-1.926 1.925v3.64h7.276v-3.64A1.925 1.925 0 0 0 18 7.222zm8.35 5.564v-3.64A4.925 4.925 0 0 0 18 4.223h-3.425a4.925 4.925 0 0 0-4.926 4.925v3.64H6.223v14.991h20.13V12.786zm-13.701 3v8.992h14.13v-8.992zm5.562 7.065v-5.137h3v5.137z",
    clipRule: "evenodd"
  })));
};
export default SvgLock;